import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SessionAuthGuard } from "./auth/guards/session-auth.guard";

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },

  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
    canActivate: [SessionAuthGuard]
  },
  {
    path: 'editUser',
    loadChildren: () => import('./modules/edit-user/edit-user.module').then(m => m.EditUserModule),
    canActivate: [SessionAuthGuard]
  },
  {
    path: 'administrator',
    loadChildren: () => import('./modules/administrator/administrator.module').then(m => m.AdministratorModule),
    canActivate: [SessionAuthGuard]
  },
  {
    path: 'fidel',
    loadChildren: () => import('./modules/fidel/fidel.module').then(m => m.FidelModule),
    // canActivate: [SessionAuthGuard]
  },

  {
    path: '404',
    loadChildren: () => import('./modules/error-page/error-page.module').then(m => m.ErrorPageModule),
  },

  { path: '**', redirectTo: '404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor() {
  }
}
